import { useContext, useEffect, useRef, useState } from "react";
import { FormUtility } from "../../../Utility/FormUtility";
import { Bando } from "../../../../models/Bando";
import Input from "../../../Form/Input";
import Select from "../../../Form/Select";
import TextArea from "../../../Form/TextArea";
import { useNavigate, useParams } from "react-router-dom";
import { BandoService } from "../../../../services/BandoService";
import ToastContext from "../../../../contexts/toast";
import StatusContext from "../../../../contexts/status";
import { IMaskInput } from "react-imask";

export default function GestioneAvviso() {
  const [validate, setValidate] = useState(false);
  const [inputErrors, setInputErrors] = useState([]);

  const [schoolYears, setSchoolYears] = useState(null);

  const [bando, setBando] = useState(new Bando());

  const [onStart, setOnStart] = useState(true);

  const bandoService = new BandoService();
  const utility = new FormUtility();

  const toastContext = useContext(ToastContext);
  const statusContext = useContext(StatusContext);

  const params = useParams();
  const navigation = useNavigate();
  const formRef = useRef(null);

  const instructions = utility.bandoInstructions;

  const [inputTableValues, setInputTableValues] = useState([
    { id: null, idEl: "1M", annoCorso: 1, ordineGrado: 'MEDIA', label: "1° media", contributo: null },
    { id: null, idEl: "2M", annoCorso: 2, ordineGrado: 'MEDIA', label: "2° media", contributo: null },
    { id: null, idEl: "3M", annoCorso: 3, ordineGrado: 'MEDIA', label: "3° media", contributo: null },
    { id: null, idEl: "1S", annoCorso: 1, ordineGrado: 'SUPERIORE', label: "1° superiore", contributo: null },
    { id: null, idEl: "2S", annoCorso: 2, ordineGrado: 'SUPERIORE', label: "2° superiore", contributo: null },
    { id: null, idEl: "3S", annoCorso: 3, ordineGrado: 'SUPERIORE', label: "3° superiore", contributo: null },
    { id: null, idEl: "4S", annoCorso: 4, ordineGrado: 'SUPERIORE', label: "4° superiore", contributo: null },
    { id: null, idEl: "5S", annoCorso: 5, ordineGrado: 'SUPERIORE', label: "5° superiore", contributo: null },
    { id: null, idEl: "6S", annoCorso: 6, ordineGrado: 'SUPERIORE', label: "6° superiore", contributo: null },
  ]);

  useEffect(() => {
    const currYear = new Date().getFullYear();

    const paramId = params.id;
    if (paramId) {
      bandoService
        .getById(paramId)
        .then((resp) => {
          setBando({ ...resp });
          setSchoolYears([
            { key: resp.annoEducativo, value: resp.annoEducativo },
          ]);
          setInputTableValues([
            { id: resp.contributi.find(el => el.ordineGrado === 'MEDIA' && el.annoCorso === 1)?.id, idEl: "1M", annoCorso: 1, ordineGrado: 'MEDIA', label: "1° media", contributo: resp.contributi.find(el => el.ordineGrado === 'MEDIA' && el.annoCorso === 1)?.contributo },
            { id: resp.contributi.find(el => el.ordineGrado === 'MEDIA' && el.annoCorso === 2)?.id, idEl: "2M", annoCorso: 2, ordineGrado: 'MEDIA', label: "2° media", contributo: resp.contributi.find(el => el.ordineGrado === 'MEDIA' && el.annoCorso === 2)?.contributo },
            { id: resp.contributi.find(el => el.ordineGrado === 'MEDIA' && el.annoCorso === 3)?.id, idEl: "3M", annoCorso: 3, ordineGrado: 'MEDIA', label: "3° media", contributo: resp.contributi.find(el => el.ordineGrado === 'MEDIA' && el.annoCorso === 3)?.contributo },
            { id: resp.contributi.find(el => el.ordineGrado === 'SUPERIORE' && el.annoCorso === 1)?.id, idEl: "1S", annoCorso: 1, ordineGrado: 'SUPERIORE', label: "1° superiore", contributo: resp.contributi.find(el => el.ordineGrado === 'SUPERIORE' && el.annoCorso === 1)?.contributo },
            { id: resp.contributi.find(el => el.ordineGrado === 'SUPERIORE' && el.annoCorso === 2)?.id, idEl: "2S", annoCorso: 2, ordineGrado: 'SUPERIORE', label: "2° superiore", contributo: resp.contributi.find(el => el.ordineGrado === 'SUPERIORE' && el.annoCorso === 2)?.contributo },
            { id: resp.contributi.find(el => el.ordineGrado === 'SUPERIORE' && el.annoCorso === 3)?.id, idEl: "3S", annoCorso: 3, ordineGrado: 'SUPERIORE', label: "3° superiore", contributo: resp.contributi.find(el => el.ordineGrado === 'SUPERIORE' && el.annoCorso === 3)?.contributo },
            { id: resp.contributi.find(el => el.ordineGrado === 'SUPERIORE' && el.annoCorso === 4)?.id, idEl: "4S", annoCorso: 4, ordineGrado: 'SUPERIORE', label: "4° superiore", contributo: resp.contributi.find(el => el.ordineGrado === 'SUPERIORE' && el.annoCorso === 4)?.contributo },
            { id: resp.contributi.find(el => el.ordineGrado === 'SUPERIORE' && el.annoCorso === 5)?.id, idEl: "5S", annoCorso: 5, ordineGrado: 'SUPERIORE', label: "5° superiore", contributo: resp.contributi.find(el => el.ordineGrado === 'SUPERIORE' && el.annoCorso === 5)?.contributo },
            { id: resp.contributi.find(el => el.ordineGrado === 'SUPERIORE' && el.annoCorso === 6)?.id, idEl: "6S", annoCorso: 6, ordineGrado: 'SUPERIORE', label: "6° superiore", contributo: resp.contributi.find(el => el.ordineGrado === 'SUPERIORE' && el.annoCorso === 6)?.contributo },
          ]);
          setTimeout(() => {
            setOnStart(false);
          }, 0);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setSchoolYears([
        {
          key: currYear + "/" + (currYear + 1).toString().substring(2, 4),
          value: currYear + "/" + (currYear + 1).toString().substring(2, 4)
        },
        {
          key: currYear + 1 + "/" + (currYear + 2).toString().substring(2, 4),
          value: currYear + 1 + "/" + (currYear + 2).toString().substring(2, 4)
        },
        {
          key: currYear + 2 + "/" + (currYear + 3).toString().substring(2, 4),
          value: currYear + 2 + "/" + (currYear + 3).toString().substring(2, 4)
        }
      ]);
      setOnStart(false);
    }

    return () => {
      statusContext.removeEvent("onbeforeunload");
    };
  }, []);

  const onChangeValue = async (event) => {
    if (onStart) return;

    const target = event.target;
    const name = target.name;
    const value = target.value;

    if (inputTableValues.find(el => el.idEl === name)) {
      setInputTableValues(prevValues =>
        prevValues.map(item =>
          item.idEl === name
            ? { ...item, contributo: value }
            : item
        )
      );
    } else {
      bando[name] = value;
      setBando({ ...bando });
    }

    statusContext.addEvent("onbeforeunload");

    if (validate) {
      setFormErrors(false);
    }
  };

  const setFormErrors = (setFocus = true) => {
    const errors = utility.getAllInputErrors(formRef);
    setInputErrors(errors.map((el) => el.id));
    if (setFocus && errors.length > 0) {
      errors[0].focus();
    }
  };

  const denyOperation = () => {
    navigation(`/gestione-avvisi`);
  };

  const sendData = (event) => {
    event.preventDefault();
    event.stopPropagation();

    setValidate(true);

    const validity = formRef.current.checkValidity();
    if (!validity) {
      setFormErrors();
      return;
    }

    setInputErrors([]);

    const service = params.id ? bandoService.update : bandoService.create;
    service({
      ...bando,
      iseeMin: parseFloat(
        bando.iseeMin.toString().replace(/\./g, "").replace(",", ".")
      ),
      iseeMax: parseFloat(
        bando.iseeMax.toString().replace(/\./g, "").replace(",", ".")
      ),
      contributi: inputTableValues.map(item => ({
        id: item.id,
        annoCorso: item.annoCorso,
        ordineGrado: item.ordineGrado,
        contributo: parseFloat(item.contributo)
      }))
    })
      .then(() => {
        toastContext.success(
          "Avviso " +
            (params.id ? "aggiornato" : "aggiunto") +
            " con successo!",
          6000
        );
        statusContext.removeEvent("onbeforeunload");

        setTimeout(() => {
          navigation(`/gestione-avvisi`);
        }, 100);
      })
      .catch((error) => {
        toastContext.error(utility.getErrorMsg(error), 12000);
      });
  };

  return (
    <div className="rtds-container rtds-my-12 ">
      <div className="rtds-mb-6">
        <h1 className="rtds-text-2xl rtds-font-bold">
          {params.id ? "Modifica Avviso" : "Inserisci Avviso"}
        </h1>
      </div>
      <div className="rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02">
        <div className="rtds-pb-6 rtds-space-y-4 rtds-border-b rtds-border-gray-02">
          <p>
            I campi obbligatori sono contrassegnati da un asterisco&nbsp;
            <abbr
              className="rtds-font-bold rtds-no-underline"
              title="obbligatorio"
            >
              *
            </abbr>
          </p>
        </div>

        <form
          noValidate
          ref={formRef}
          id="hasValidationForm"
          className="has-js-validation-form rtds-py-6 rtds-space-y-4"
          onSubmit={sendData}
        >
          <div className="rtds-field-row">
            <Input
              label={"Titolo"}
              required
              id={"nome"}
              inputErrors={inputErrors}
              classInput={"rtds-text-sm rtds-input-placeholder rtds-pr-12"}
              type={"text"}
              onChange={(event) => onChangeValue(event)}
              value={bando.nome || ""}
              disabled={bando.id}
              maxLength={50}
            />
            <Select
              classDiv={"rtds-mt-3 lg:rtds-mt-0"}
              label={"Anno Scolastico"}
              required
              id={"annoEducativo"}
              inputErrors={inputErrors}
              classSelect={""}
              onChange={(event) => onChangeValue(event)}
              baseOption={"Seleziona Anno Scolastico"}
              options={schoolYears}
              value={bando.annoEducativo || ""}
              disabled={bando.id}
            />
          </div>

          <TextArea
            label={"Descrizione"}
            id={"descrizione"}
            inputErrors={inputErrors}
            classTextArea={"rtds-text-sm rtds-input-placeholder rtds-pr-12"}
            type={"text"}
            onChange={(event) => onChangeValue(event)}
            value={bando.descrizione || ""}
            maxLength={300}
          />

          <Input
            label={"Link"}
            id={"link"}
            classInput={"rtds-text-sm rtds-input-placeholder"}
            type={"text"}
            onChange={(event) => onChangeValue(event)}
            value={bando.link || ""}
            maxLength={150}
          />

<div className="rtds-field-row">
    <Select
              classDiv={"rtds-mt-3 lg:rtds-mt-0"}
              label={"Regole Avviso"}
              required
              id={"instructions"}
              inputErrors={inputErrors}
              classSelect={""}
              onChange={(event) => onChangeValue(event)}
              baseOption={"Seleziona un valore"}
              options={instructions}
              value={bando.instructions || ""}              
            />
</div>

          <div className="rtds-field-row">
            <div className="rtds-input-field rtds-gap-1">
              <label
                htmlFor="iseeMin"
                className="rtds-input-field__label undefined"
              >
                ISEE minimo *
              </label>
              <div className="relative">
                <IMaskInput
                  value={bando.iseeMin?.toString() || ""}
                  onAccept={(value) =>
                    onChangeValue({ target: { name: "iseeMin", value } })
                  }
                  mask={Number}
                  scale={2}
                  signed={"false"}
                  thousandsSeparator="."
                  radix=","
                  normalizeZeros={true}
                  padFractionalZeros={true}
                  min={0}
                  max={Number(bando.iseeMax) || 999999.99}
                  id="iseeMin"
                  name="iseeMin"
                  className={
                    "rtds-text-sm rtds-input-placeholder rtds-pr-12 rounded-md w-full" +
                    (inputErrors?.includes("iseeMin") ? " input-error-mask" : "")
                  }
                  required
                />
                {inputErrors?.includes("iseeMin") && 
                  <svg
                    style={{ color: '#991b1b' }}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <use xlinkHref="/icons.svg#outline--exclamation-circle" />
                  </svg>
                }
              </div>
              {inputErrors?.includes("iseeMin") && 
                <p style={{ color: "#991b1b" }} className="text-sm mt-1">
                  {!bando.iseeMin
                    ? "Campo obbligatorio"
                    : "Isee minimo deve essere minore o uguale a ISEE massimo"}
                </p>
              }
            </div>

            <div className="rtds-input-field rtds-gap-1 rtds-mt-3 lg:rtds-mt-0">
              <label htmlFor="iseeMax" className="rtds-input-field__label undefined">
                ISEE massimo *
              </label>
              <div className="relative">
                <IMaskInput
                  value={bando.iseeMax?.toString() || ""}
                  onAccept={(value) =>
                    onChangeValue({ target: { name: "iseeMax", value } })
                  }
                  mask={Number}
                  scale={2}
                  signed={"false"}
                  thousandsSeparator="."
                  radix=","
                  normalizeZeros={true}
                  padFractionalZeros={true}
                  min={Number(bando.iseeMin) || 0}
                  id="iseeMax"
                  name="iseeMax"
                  className={
                    "rtds-text-sm rtds-input-placeholder rtds-pr-12 rounded-md w-full" +
                    (inputErrors?.includes("iseeMax") ? " input-error-mask" : "")
                  }
                  required
                />
                {inputErrors?.includes("iseeMax") && 
                  <svg
                    style={{ color: '#991b1b' }}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <use xlinkHref="/icons.svg#outline--exclamation-circle" />
                  </svg>
                }
              </div>
              {inputErrors?.includes("iseeMax") && 
                <p style={{ color: "#991b1b" }} className="text-sm mt-1">
                  {!bando.iseeMax
                    ? "Campo obbligatorio"
                    : "Isee massimo deve essere maggiore o uguale a ISEE minimo"}
                </p>
              }
            </div>
          </div>

          <div className="rtds-overflow-x-auto ">
            <div className="rtds-overflow-x-auto rtds-py-4">
              <table className="rtds-table rtds-w-full rtds-border rtds-border-gray-300 rtds-border-collapse">
                <caption className="rtds-text-left rtds-text-sm rtds-font-semibold  rtds-py-2">
                  UCS
                </caption>

                <thead>
                  <tr className="rtds-bg-gray-100">
                    <th
                      scope="col"
                      className="rtds-border rtds-border-gray-300 rtds-px-4 rtds-py-2 rtds-text-left"
                    >
                      Ordine e Grado
                    </th>
                    <th
                      scope="col"
                      className="rtds-border rtds-border-gray-300 rtds-px-4 rtds-py-2 rtds-text-left"
                    >
                      Importo €
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {inputTableValues.map((item, index) => {
                    const hasError = inputErrors?.includes(item.idEl);
                    const errorId = `${item.idEl}-error`;

                    return (
                      <tr
                        key={item.idEl}
                        className="rtds-border-t rtds-border-gray-200 odd:bg-white even:bg-gray-50"
                      >
                        <th
                          scope="row"
                          className="rtds-px-4 rtds-py-2 rtds-font-normal"
                        >
                          <p className="rtds-text-sm rtds-text-gray-700">
                            {item.label}
                          </p>
                        </th>
                        <td className="rtds-px-4 rtds-py-2">
                          <div className="relative">
                            <IMaskInput
                              value={item.contributo?.toString() || ""}
                              onAccept={(value) =>
                                onChangeValue({
                                  target: { name: item.idEl, value },
                                })
                              }
                              mask={Number}
                              scale={2}
                              signed={"false"}
                              thousandsSeparator="."
                              radix=","
                              normalizeZeros={true}
                              padFractionalZeros={true}
                              name={item.idEl}
                              id={item.idEl}
                              required
                              aria-describedby={hasError ? errorId : undefined}
                              className={
                                "rtds-text-sm rtds-input-placeholder rtds-pr-12 rounded-md w-full" +
                                (hasError ? " input-error-mask" : "")
                              }
                            />
                            {hasError && 
                              <svg
                                style={{ color: '#991b1b' }}
                                className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                fill="currentColor"
                                viewBox="0 0 16 16"
                              >
                                <use xlinkHref="/icons.svg#outline--exclamation-circle" />
                              </svg>
                            }
                          </div>
                          {hasError && (
                            <p
                              id={errorId}
                              className="rtds-text-sm rtds-mt-1 rtds-text-red-800"
                              style={{ color: "#991b1b" }}
                            >
                              Campo obbligatorio
                            </p>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          <div className="rtds-border-gray-02 rtds-border-b rtds-border-t rtds-p-3 rtds-flex sm:justify-end justify-center">
            <div className="rtds-form-actions">
              <div
                className="rtds-inline-flex rtds-gap-1"
                role="group"
                aria-label="Azioni"
              >
                <button
                  type="button"
                  className="rtds-btn rtds-btn--secondary rtds-btn--icon-left rtds-group/button rtds-form-submit"
                  onClick={() => denyOperation()}
                >
                  <svg
                    className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6  group-hover/button:-rtds-translate-x-1"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-uturn-left`}
                    />
                  </svg>{" "}
                  Annulla
                </button>
                <button
                  type="submit"
                  className="rtds-btn rtds-btn--primary rtds-form-submit rtds-btn--icon-right rtds-group/button"
                >
                  {params.id ? "Salva" : "Salva"}
                  <svg
                    className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${
                        params.id
                          ? "solid--chevron-right"
                          : "solid--chevron-right"
                      }`}
                    />
                  </svg>{" "}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
